import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import { ReactComponent as IconLock } from "../Images/icon_lock.svg";
import { ReactComponent as IconPerson } from "../Images/icon_setting_person.svg";
import { ReactComponent as IconPhone } from "../Images/icon_setting_phone.svg";
import { ReactComponent as IconNickname } from "../Images/icon_setting_nickname.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import { postJson } from "../Utils/apiUtils";
import { getCompanyProfile } from "../Utils/sessionUtils.js";

const AccountNSettingBox = ({
  handleClickX,
  handleClickEditName,
  handleClickResetPW,
  handleClickSetLogo,
  handleClickSetNickname,
  handleClickSetAdmin,
}) => {
  const navigate = useNavigate();
  const companyProfile = getCompanyProfile();
  const [companyName, setCompanyName] = useState(companyProfile.companyName);
  const [companyNameEn, setCompanyNameEn] = useState(companyProfile.companyNameEn);
  const [email, setEmail] = useState(companyProfile.email);

  useEffect(() => {
    const getCompanyInfo = async () => {
      try {
        const response = await postJson(
          "/dashboard/company/getCompanyInfo",
          {},
          navigate
        );

        if (response.code !== 200 || !response.data) {
          return;
        }

        setCompanyName(response.data.companyName ?? "");
        setCompanyNameEn(response.data.companyNameEn ?? "");
        setEmail(response.data.email ?? "");
      } catch (error) {
        console.error("기업 정보 조회 중 에러: ", error);
      }
    };

    getCompanyInfo();
  }, [navigate]);

  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          계정 및 환경설정
        </p>
        <div
          style={{
            marginLeft: "auto",
            cursor: "pointer",
          }}
        >
          <IconCrossRound
            onClick={() => {
              handleClickX();
              window.location.reload();
            }}
          />
        </div>
      </div>

      <div className="hrz-wrapper" style={{ marginTop: "30px" }}>
        <p className="bold-text" style={{ color: "#8E96A0" }}>
          기본정보
        </p>
      </div>

      <div className="graybox" style={{ marginTop: "10px" }}>
        <p className="medium-text" style={{ fontSize: "18px" }}>
          {companyName}
        </p>
        {companyNameEn && (
          <>
            <div style={{ height: "6px" }} />
            <p className="medium-text" style={{ color: "#888888" }}>
              {companyNameEn}
            </p>
          </>
        )}
        <div style={{ height: "8px" }} />
        <p className="medium-text" style={{ color: "#888888" }}>
          {email}
        </p>

        <div style={{ width: "460px" }}>
          <div
            className="blueBtn-base center"
            style={{
              width: "88px",
              height: "36px",
              borderRadius: "8px",
              marginTop: "8px",
              marginLeft: "auto",
            }}
            onClick={handleClickEditName}
          >
            <p
              className="medium-text"
              style={{ fontSize: "14px", color: "#ffffff" }}
            >
              기업명 변경
            </p>
          </div>
        </div>
      </div>

      <p className="bold-text" style={{ color: "#8E96A0", marginTop: "40px" }}>
        설정
      </p>

      <div className="settingMenu" onClick={handleClickResetPW}>
        <div style={{ width: "14px" }} />
        <IconLock />
        <div style={{ width: "8px" }} />
        <p className="medium-text">비밀번호 재설정</p>
      </div>

      <div className="settingMenu" onClick={handleClickSetLogo}>
        <div style={{ width: "14px" }} />
        <IconPhone />
        <div style={{ width: "8px" }} />
        <p className="medium-text">앱 메인화면 로고 설정</p>
      </div>

      {/* 아직 부서별 닉네임 기능은 미제공이라 설정 메뉴를 숨김 */}
      {/* <div className="settingMenu" onClick={handleClickSetNickname}>
        <div style={{ width: "14px" }} />
        <IconNickname />
        <div style={{ width: "8px" }} />
        <p className="medium-text">앱 닉네임 표기 방식 설정</p>
      </div> */}

      <div className="settingMenu" onClick={handleClickSetAdmin}>
        <div style={{ width: "14px" }} />
        <IconPerson />
        <div style={{ width: "8px" }} />
        <p className="medium-text">관리자 정보 설정</p>
      </div>
    </Box>
  );
};

const AccountNSetting = ({
  handleClickX,
  handleClickEditName,
  handleClickResetPW,
  handleClickSetLogo,
  handleClickSetNickname,
  handleClickSetAdmin,
}) => {
  return (
    <LayoutModal
      Modal={
        <AccountNSettingBox
          handleClickX={handleClickX}
          handleClickEditName={handleClickEditName}
          handleClickResetPW={handleClickResetPW}
          handleClickSetLogo={handleClickSetLogo}
          handleClickSetNickname={handleClickSetNickname}
          handleClickSetAdmin={handleClickSetAdmin}
        />
      }
    />
  );
};

const Box = styled.div`
  width: auto;
  height: 646px;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  .graybox {
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
  }
  .settingMenu {
    width: 500px;
    height: 50px;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-top: 10px;
    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

export default AccountNSetting;
